/**
 * Single source of truth for task-status colors and labels.
 *
 * Two visual conventions exist across the app:
 *   1. Solid pill (white text on saturated bg) — used by the main task lists
 *      and dashboard. Import STATUS_COLORS / STATUS_LABELS.
 *   2. Soft chip (dark text on tinted bg) — used by reporting tables that
 *      render lots of inline status badges. Import STATUS_COLORS_SOFT /
 *      STATUS_LABELS_SHORT.
 *
 * Keep both in lock-step when adding a new status.
 */

// ---- Solid pills (Tasks / MemberWorkspace / Dashboard / CreateTaskDialog) ---
export const STATUS_COLORS = {
  pending: 'bg-slate-500',
  in_progress: 'bg-blue-500',
  pending_with_client: 'bg-orange-500',
  pending_with_member: 'bg-purple-500',
  on_hold_client: 'bg-amber-500',
  pending_review: 'bg-cyan-600',
  completed: 'bg-green-500',
  overdue: 'bg-red-600',
};

export const STATUS_LABELS = {
  pending: 'Pending',
  in_progress: 'In Progress',
  pending_with_client: 'Pending w/ Client',
  pending_with_member: 'Pending w/ Member',
  on_hold_client: 'On Hold',
  pending_review: 'Pending Review',
  completed: 'Completed',
  overdue: 'Overdue',
};

// ---- Soft chips (Transfer / Timesheet / TeamEfficiency reporting tables) ---
export const STATUS_COLORS_SOFT = {
  pending: 'bg-slate-100 text-slate-700',
  in_progress: 'bg-blue-100 text-blue-700',
  completed: 'bg-green-100 text-green-700',
  overdue: 'bg-red-100 text-red-700',
  pending_with_client: 'bg-orange-100 text-orange-700',
  pending_with_member: 'bg-purple-100 text-purple-700',
  on_hold_client: 'bg-amber-100 text-amber-700',
};

export const STATUS_LABELS_SHORT = {
  pending: 'Pending',
  in_progress: 'In Progress',
  completed: 'Completed',
  overdue: 'Overdue',
  pending_with_client: 'W/ Client',
  pending_with_member: 'W/ Member',
  on_hold_client: 'On Hold',
};

// Full-word variant (Dashboard widgets render with "with" instead of "w/")
export const STATUS_LABELS_FULL = {
  pending: 'Pending',
  in_progress: 'In Progress',
  pending_with_client: 'Pending with Client',
  pending_with_member: 'Pending with Member',
  on_hold_client: 'On Hold',
  pending_review: 'Pending Review',
  completed: 'Completed',
  overdue: 'Overdue',
};
